import api from "services/api";
import { ClusterGroupSchema } from "utils/schemas";
import { getClusterGroupEntity } from "../selectors/details";

import { WorkloadNamespaceSchema } from "utils/schemas";

import moment from "moment";
import { GENERAL_DATE_FORMAT } from "utils/constants";
import { namespacesFetcher } from "../services/workloads/namespaces";
import dataFetcher from "modules/dataFetcher";

export function fetchClusterGroup(uid) {
  return (dispatch) => {
    const promise = api.get(`v1/clustergroups/${uid}`);

    dispatch({
      type: "FETCH_CLUSTER_GROUP",
      promise,
      schema: ClusterGroupSchema,
    });

    return promise;
  };
}

export function refreshClusterGroup() {
  return function thunk(dispatch, getState) {
    const clusterGroup = getClusterGroupEntity(getState());
    const promise = api.get(`v1/clustergroups/${clusterGroup?.metadata?.uid}`);
    dispatch({
      promise,
      type: "REFRESH_CLUSTER_GROUP",
      schema: ClusterGroupSchema,
    });
    return promise;
  };
}

export function getClusterGroupByUid(uid) {
  return (dispatch, getState) => {
    const clusterGroup = getClusterGroupEntity(getState());

    if (clusterGroup?.metadata?.uid === uid) {
      return;
    }
    return dispatch(fetchClusterGroup(uid));
  };
}

export function fetchNamespacesConsumption() {
  return async function thunk(dispatch, getState) {
    const uid = getState().location.params?.id;
    const promise = async function loadData() {
      const startTime = moment()
        .subtract(1, "hour")
        .utc()
        .format(GENERAL_DATE_FORMAT);
      const endTime = moment().utc().format(GENERAL_DATE_FORMAT);

      const filters = {
        filter: {
          workspaces: [uid],
          endTime,
          startTime,
          includeMasterMachines: true,
        },
        options: {
          groupBy: "namespace",
          period: 60,
        },
      };
      const rawData = await api.post(
        "v1/dashboard/spectroclusters/resources/consumption",
        filters
      );

      const { result: namespaces } = namespacesFetcher.selector(getState());

      return rawData.resources.map((resource) => {
        const namespace = (namespaces?.items || []).find((ns) => {
          return ns.metadata.entity.name === resource.entity.name;
        });

        return {
          metadata: {
            entity: {
              ...resource.entity,
              uid: namespace?.metadata.entity.uid,
            },
          },
          status: {
            usage: {
              total: resource.total,
            },
          },
        };
      });
    };

    dispatch({
      type: "CLUSTER_WORKSPACE_WORKLOAD_NAMESPACES_CONSUMPTION",
      promise: promise(),
      schema: [WorkloadNamespaceSchema],
    });
  };
}

export const fetchAllDashboardClusters = dataFetcher({
  selectors: ["dashboardClusters"],
  async fetchData() {
    const response = await api.post("v1/dashboard/spectroclusters");
    return {
      items: response?.items,
    };
  },
});
